export default __webpack_public_path__ + "static/media/widgets.98c0ec04.svg";